import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  Link,
  Breadcrumbs,
  InputAdornment,
  TextField,
  Stack,
  Button,
  Grid,
  AppBar,
} from "@mui/material";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { useSelector } from "react-redux";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { ordertrackingdata } from "../../assets/Griddata";
import { externalgetApi } from "../../services/external/externalApis";
import {
  SETTINGS_API_04,
  COMPCODE,
  LOCCODE,
  RESTCODE,
  STS,
} from "../../api/ApiModel";
import SearchAppBar from "../../components/common/search";

function ViewOrderTracking() {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTINGS_API_04, "get", {
          COMPCODE,
          LOCCODE,
          RESTCODE,
          STS: CON_STATUS_ACTIVE,
        });
        const mappedData = mapResultToRows(result);
        setData(mappedData);
        setFilteredData(mappedData);
        setIsLoading(false);
        console.log("result", result);
      } catch (err) {
        console.error("Error fetching data:", err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      ORDERSTSCODE: item.ORDERSTSCODE,
      ORDERSTATUS: item.ORDERSTATUS,
      SMSTEXT: item.SMSTEXT,
      ENUSER: item.ENUSER,
      STS: item.STS,
      SEQ: item.SEQ,
    }));
  };

  useEffect(() => {
    if (searchText === "") {
      setFilteredData(data);
    } else {
      const filtered = data.filter((item) => {
        return (
          item.ORDERSTATUS.toLowerCase().includes(searchText.toLowerCase()) ||
          item.ENUSER.toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        );
      });
      setFilteredData(filtered);
    }
  }, [searchText, data]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.ORDERSTSCODE === id);
      if (selectedItem) {
        navigate(`/OrderTracking`, { state: { selectedItem, actionText } });
      }
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (ORDERSTSCODE) => handleItemClick(ORDERSTSCODE, "Edit"),
    },
  ];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover">Home</Link>
                <Link underline="hover">Settings</Link>
                <Link underline="hover">View Order Tracking</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                <Button
                  onClick={() => navigate("/OrderTracking")}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <ViewData
        columns={ordertrackingdata.columns}
        rows={filteredData.map((item) => ({ ...item, id: item.ORDERSTSCODE }))}
        menuItems={menuItems}
        tabletitle={ordertrackingdata.name}
        gridid="ORDERSTSCODE"
      />
    </div>
  );
}

export default ViewOrderTracking;
